<template>
  <div style="margin-top: 10px">
    <h3>{{ name.toUpperCase() }}</h3>
  </div>
</template>

<script>
export default {
  props: ['name'],
}
</script>



// WEBPACK FOOTER //
// src/components/MatchLive/StatisticsByTeam/Header.vue